import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { Formik } from "formik";

import { errorMsg, LoadingSpinner } from "../Shared";
import { MappixDesign } from "./";
import * as commonApi from "../../api/commonApi";
import { Common, MESSAGES, RolesEnum, SessionStorageKeys, CommonPages, SuperAdmin } from "../../helper";
import { isEmptyObject, has, SessionStorage } from "../../util";
import { otpValidationSchema } from "../../validators";
import { setUserInfo } from "../../store/userSlice";
import { setUserName, setUserType } from "../../store/loginSlice";

import "../../assets/stlyes/Common/LoginNew.scss";

import RightArrow from "../../assets/images/RightArrow.png";
import HexagonCharacter from "../../assets/images/HexagonCharacter.png";

const Authentication = () => {
  const navigate = useNavigate();
  const otpRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.login.user);

  const OAuth = async (formData) => {
    setIsLoading(true);
    var email = userInfo.email;
    var otp = parseInt(formData.otp)
    const otpAuth = await commonApi.user2FA({ email: email, otp: otp });
    if (!isEmptyObject(otpAuth)) {
      dispatch(setUserInfo(otpAuth.Items))
      SessionStorage.setItem(SessionStorageKeys.SessionToken, otpAuth.Items.jwt)
      dispatch(setUserName(otpAuth.Items.userName));
      dispatch(setUserType(otpAuth.Items.userType));
      if (has(otpAuth.Items.userType, RolesEnum.MappixAdmin)) { navigate(SuperAdmin.superAdmin); }
      else if (has(otpAuth.Items.userType, RolesEnum.Admin)) { navigate(CommonPages.dashboard); }
      else {
        SessionStorage.setItem(SessionStorageKeys.SessionToken, otpAuth.Items.jwt)
        dispatch(setUserName(otpAuth.Items.userName));
        dispatch(setUserType(otpAuth.Items.userType));
        navigate(CommonPages.dashboard);
      }
    } else { errorMsg(MESSAGES.LOGIN_FAILED); setIsLoading(false); }
  }

  useEffect(() => {
    let token = SessionStorage.getItem(SessionStorageKeys.SessionToken);
    if (token) navigate(CommonPages.dashboard);
  }, [])

  return (
    <div className="main-login">
      {isLoading && <LoadingSpinner />}
      <div className="left-part">
        <div className="first-div"><MappixDesign /></div>
      </div>
      <div className="right-part">
        <div className="first-div">
          <p className="welcome-title">{Common.PleaseEnterOTP}</p>
          <p className="welcome-subtitle">{MESSAGES.Please_Enter_Otp_Sent}</p>
          <Formik initialValues={{ otp: "" }} validationSchema={otpValidationSchema} onSubmit={(values) => {
            const formData = { otp: values.otp }
            OAuth(formData);
          }}>
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <Form.Group>
                  <div><Form.Control type="tel" pattern="[0-9]*" name="otp" id="userPasswordPlaceholder" placeholder={Common.Otp} onChange={handleChange} onBlur={handleBlur} value={values.otp} className={touched.otp && errors.otp ? "user_password" : "user_password_active"} ref={otpRef} autoComplete="off" maxLength={6} minLength={6} /></div>&nbsp;
                  {touched.otp && errors.otp ? (<p className="error-message">{errors.otp}</p>) : <p>{""}</p>}
                </Form.Group>
                <div className="submit-button-div">
                  <Button type="submit" className="submit-button">{Common.Login}<img src={RightArrow} alt="" type="image" width="65px" className="login-icon" /></Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <div className="second-div"><img src={HexagonCharacter} className="hexagon-logo" alt="hexagon-character"></img></div>
      </div>
    </div>
  )
}

export { Authentication }
